import axios from 'axios';


export default {
  createProducer (data) {
    return axios.post(`/producers`, data)
      .then(response => response.data);
  },
  getProducers () {
    return axios.get(`/producers`)
      .then(response => response.data);
  },
  getProducer (id) {
    return axios.get(`/producers/${id}`)
      .then(response => response.data);
  },
  updateProducer (data) {
    return axios.put(`/producers/${data.producer_id}`, data)
      .then(response => response.data);
  },
  deleteProducer (id) {
    return axios.delete(`/producers/${id}`)
      .then();
  }
};
